export default __webpack_public_path__ + "static/LimitedEditionProduct-54c7535a1e643ba00dccf44fe51a33f2.png";